module.exports = __webpack_public_path__ + "media/images/webpage/shared/sale/ogp-14bc4ee5b66c2b9d6cd17dd179d2222f.webp";